import { MiddlewareAPI, Action, Dispatch, Middleware } from "redux";

import { LOCATION_CHANGED, LocationChangedAction } from "redux-little-router";

interface Options<TState> {
    getPhysioOrigins: (state: TState) => string[];
    notAllowedAction: Action;
}

export const restrictRoutesByPhysioOriginsMiddleware = <TState>(options: Options<TState>): Middleware => {

    return (api: MiddlewareAPI) => (next: Dispatch) => (action: LocationChangedAction) => {
        if (action.type === LOCATION_CHANGED) {
            const routeChangedAction = action;
            const physioOrigins = routeChangedAction.payload.result?.physioOrigins as string[];
            if (physioOrigins && !options.getPhysioOrigins(api.getState()).some(p => physioOrigins.indexOf(p) > -1)) {
                api.dispatch(options.notAllowedAction);
                throw new Error("No access to required product");
            }
        }

        return next(action);
    };
};
